import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    size: { default: 5 },
    color: { default: "blue" }
  },
  setup(__props: any) {



const classes = computed(() => `w-${__props.size} h-${__props.size} border-t-${__props.color}-600`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([classes.value, 'border-3 border-white border-t-3 rounded-full animate-spin'])
  }, null, 2))
}
}

})